export default {
    auto: 'Automatisation',
    planned: 'Planifiée',
    mass_mailing: 'Envoi de masse',
};
